module.exports = __webpack_public_path__ + "static/img/caseImg2.d492761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg2.jpg
// module id = 8+g7
// module chunks = 0